import { render, staticRenderFns } from "./CoronaResponse.vue?vue&type=template&id=6a166be6"
import script from "./CoronaResponse.vue?vue&type=script&lang=js"
export * from "./CoronaResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports